import {withStyles} from "@mui/styles";
import axios from 'axios';
import * as React from "react";
import {Config} from '../../config/config';
import {Helpers} from '../../utils/helpers';
import {PopupMessage} from "../../utils/message";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MenuItem, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {DateTimePicker, LocalizationProvider} from "@mui/lab";

// Green: '✔'
const TICK = <span style={{color: 'green'}}>✔</span>;
// Red: '✘'
const CROSS = <span style={{color: 'red'}}>✘</span>;

const MailTypes = [
    {value: 'SYSTEM', label: 'SYSTEM'},
]

class broadcastMailMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            filter: {
                offset: 0,
                limit: 50,
            },
            mails: [],
            createMailPopup: {
                open: false,
                subject: {
                    key: '',
                    value: '',
                },
                content: {
                    key: '',
                    value: '',
                },
                attachment: '[]',
                type: 'SYSTEM',
                params: '{}',
                isBroadcast: false,
                isTimeLimited: false,
                validUntil: new Date(),
                isActive: true,
                receiverIds: "",
                errorMessage: '',
            },
            updateMailPopup: {
                open: false,
                id: '',
                subject: {
                    key: '',
                    value: '',
                },
                content: {
                    key: '',
                    value: '',
                },
                attachment: '[]',
                type: 'SYSTEM',
                params: '{}',
                isBroadcast: false,
                isTimeLimited: false,
                validUntil: new Date(),
                isActive: true,
                receiverIds: "",
                errorMessage: '',
            },
        }
    }

    componentDidMount(): void {
        this.fetchData();
    }

    async fetchData() {
        const userId = this.state.userId;
        const url = `${Config.getInstance.apiUrl}/api/broadcast-mail`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const {filter} = this.state;

        this.setState({
            loading: true,
        });

        const response = await axios.get(url, {params: filter, headers});

        const success = response.data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const data = response.data;
            const mails = data.mails;

            this.setState({mails});
        } else {
            PopupMessage.error(`Error: ${response.data.message}`)
        }
    }

    async createMail() {
        try {
            const {createMailPopup} = this.state;
            const url = `${Config.getInstance.apiUrl}/api/broadcast-mail`;

            const headers = {
                Authorization: Helpers.getSessionId(),
            }

            let parsedAttachment = [];

            if (!createMailPopup.isBroadcast) {
                if (createMailPopup.receiverIds.length === 0) {
                    createMailPopup.errorMessage = `Receiver Ids must not be empty.`;
                    this.setState({createMailPopup});
                    return;
                }
            }

            if (createMailPopup.subject.value.length === 0 || createMailPopup.content.value.length === 0) {
                createMailPopup.errorMessage = `Subject and Content must not be empty.`;
                this.setState({createMailPopup});
                return;
            }

            try {
                parsedAttachment = JSON.parse(createMailPopup.attachment);

                // Check if attachment is an array
                if (!Array.isArray(parsedAttachment)) {
                    createMailPopup.errorMessage = `Attachment must be an array.`;
                    this.setState({createMailPopup});
                    return;
                }
            } catch (e) {
                createMailPopup.errorMessage = `Parse Error on Attachment: ${e.message}`;
                this.setState({createMailPopup});
                return;
            }

            let parsedParams = {};

            try {
                parsedParams = JSON.parse(createMailPopup.params);

                // Check if params is an object, not an array
                if (typeof parsedParams !== 'object' || Array.isArray(parsedParams)) {
                    createMailPopup.errorMessage = `Params must be an object.`;
                    this.setState({createMailPopup});
                    return;
                }

            } catch (e) {
                createMailPopup.errorMessage = `Parse Error on Params: ${e.message}`;
                this.setState({createMailPopup});
                return;
            }

            const isTimeLimited = createMailPopup.isTimeLimited;

            const params = {
                subject: createMailPopup.subject,
                content: createMailPopup.content,
                attachment: parsedAttachment,
                type: createMailPopup.type,
                params: parsedParams,
                isBroadcast: createMailPopup.isBroadcast,
                isTimeLimited: createMailPopup.isTimeLimited,
                validUntil: isTimeLimited ? createMailPopup.validUntil : null,
                isActive: createMailPopup.isActive,
                receiverIds: createMailPopup.receiverIds,
            };

            this.setState({
                loading: true,
            });

            const response = await axios.post(url, params, {headers});

            const success = response.data.success;

            this.setState({
                loading: false,
            });

            if (success) {
                this.onChangeCreateMailPopup('open', false);
                PopupMessage.success(`Mail Created Successfully`);
                this.fetchData();
            } else {
                PopupMessage.error(`Error: ${response.data.message}`)
            }
        }
        catch (e) {
            PopupMessage.error(`createMail Clientside Error: ${e.message}`)
        }
    }

    async updateMail() {
        try {
            const {updateMailPopup} = this.state;
            const url = `${Config.getInstance.apiUrl}/api/broadcast-mail`;

            const headers = {
                Authorization: Helpers.getSessionId(),
            }

            if (updateMailPopup.subject.value.length === 0 || updateMailPopup.content.value.length === 0) {
                updateMailPopup.errorMessage = `Subject and Content must not be empty.`;
                this.setState({updateMailPopup});
                return;
            }

            let parsedAttachment = [];

            try {
                parsedAttachment = JSON.parse(updateMailPopup.attachment);

                // Check if attachment is an array
                if (!Array.isArray(parsedAttachment)) {
                    updateMailPopup.errorMessage = `Attachment must be an array.`;
                    this.setState({updateMailPopup});
                    return;
                }
            } catch (e) {
                updateMailPopup.errorMessage = `Parse Error on Attachment: ${e.message}`;
                this.setState({updateMailPopup});
                return;
            }

            let parsedParams = {};

            try {
                parsedParams = JSON.parse(updateMailPopup.params);

                // Check if params is an object, not an array
                if (typeof parsedParams !== 'object' || Array.isArray(parsedParams)) {
                    updateMailPopup.errorMessage = `Params must be an object.`;
                    this.setState({updateMailPopup});
                    return;
                }

            } catch (e) {
                updateMailPopup.errorMessage = `Parse Error on Params: ${e.message}`;
                this.setState({updateMailPopup});
                return;
            }

            const isTimeLimited = updateMailPopup.isTimeLimited;

            const params = {
                id: updateMailPopup.id,
                subject: updateMailPopup.subject,
                content: updateMailPopup.content,
                attachment: parsedAttachment,
                type: updateMailPopup.type,
                params: parsedParams,
                isBroadcast: updateMailPopup.isBroadcast,
                isTimeLimited: updateMailPopup.isTimeLimited,
                validUntil: isTimeLimited ? updateMailPopup.validUntil : null,
                isActive: updateMailPopup.isActive,
                receiverIds: updateMailPopup.receiverIds,
            };

            this.setState({
                loading: true,
            });

            const response = await axios.put(url, params, {headers});

            const success = response.data.success;

            this.setState({
                loading: false,
            });

            if (success) {
                this.onChangeUpdateMailPopup('open', false);
                PopupMessage.success(`Mail Updated Successfully`);
                this.fetchData();
            } else {
                PopupMessage.error(`Error: ${response.data.message}`)
            }
        }
        catch (e) {
            PopupMessage.error(`updateMail Clientside Error: ${e.message}`)
        }
    }

    async deleteMail() {
        try {
            // Confirm popup
            if (!window.confirm("Are you sure you want to delete this mail?")) {
                return;
            }

            const {updateMailPopup} = this.state;
            const url = `${Config.getInstance.apiUrl}/api/broadcast-mail/${updateMailPopup.id}`;

            const headers = {
                Authorization: Helpers.getSessionId(),
            }

            const params = {
                id: updateMailPopup.id,
            };

            this.setState({
                loading: true,
            });

            const response = await axios.delete(url, {data: params, headers});

            const success = response.data.success;

            this.setState({
                loading: false,
            });

            if (success) {
                this.onChangeUpdateMailPopup('open', false);
                PopupMessage.success(`Mail deleted successfully.`);
                this.fetchData();
            } else {
                PopupMessage.error(`Error: ${response.data.message}`)
            }
        }
        catch (e) {
            PopupMessage.error(`deleteMail Clientside Error: ${e.message}`)
        }
    }

    onChangeFilter = (key: string, value: any) => {
        const {filter} = this.state;
        filter[key] = value;
        this.setState({filter});
    }

    onChangeCreateMailPopup = (key: string, value: any) => {
        const {createMailPopup} = this.state;
        createMailPopup[key] = value;
        this.setState({createMailPopup});
    }

    onCreateChangeTime = (key: string, value: any) => {
        const {createMailPopup} = this.state;
        createMailPopup[key] = value;
        this.setState({createMailPopup});
    }

    onChangeUpdateMailPopup = (key: string, value: any) => {
        const {updateMailPopup} = this.state;
        updateMailPopup[key] = value;
        this.setState({updateMailPopup});
    }

    onUpdateChangeTime = (key: string, value: any) => {
        const {updateMailPopup} = this.state;
        updateMailPopup[key] = value;
        this.setState({updateMailPopup});
    }

    focusOnMail = (mail: any) => {
        const {updateMailPopup} = this.state;

        updateMailPopup.open = true;
        updateMailPopup.id = mail.id;
        updateMailPopup.subject = JSON.parse(mail.subject);
        updateMailPopup.content = JSON.parse(mail.content);
        updateMailPopup.attachment = JSON.stringify(mail.attachment);
        updateMailPopup.type = mail.type;
        updateMailPopup.params = JSON.stringify(mail.params);
        updateMailPopup.isBroadcast = mail.isBroadcast;
        updateMailPopup.isTimeLimited = mail.isTimeLimited;
        updateMailPopup.validUntil = mail.validUntil;
        updateMailPopup.isActive = mail.isActive;
        updateMailPopup.receiverIds = mail.receiverIds;

        this.setState({updateMailPopup});
    }

    renderCreateMailPopup() {
        const {createMailPopup} = this.state;

        return <Dialog
            open={createMailPopup.open}
            onClose={() => this.onChangeCreateMailPopup('open', false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>Create Mail</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Broadcast</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                checked={createMailPopup.isBroadcast}
                                onChange={(e) => this.onChangeCreateMailPopup('isBroadcast', e.target.checked)}
                                name="isBroadcast"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Receiver Ids</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                disabled={createMailPopup.isBroadcast}
                                label="Receiver Ids user1,user2,user3..."
                                value={createMailPopup.receiverIds}
                                onChange={(e) => this.onChangeCreateMailPopup('receiverIds', e.target.value)}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Active</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                disabled={!createMailPopup.isBroadcast}
                                checked={createMailPopup.isActive}
                                onChange={(e) => this.onChangeCreateMailPopup('isActive', e.target.checked)}
                                name="isActive"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Time Limited</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                disabled={!createMailPopup.isBroadcast}
                                checked={createMailPopup.isTimeLimited}
                                onChange={(e) => this.onChangeCreateMailPopup('isTimeLimited', e.target.checked)}
                                name="isTimeLimited"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Valid Until</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label="Valid Until"
                                    disabled={!createMailPopup.isBroadcast || !createMailPopup.isTimeLimited}
                                    value={createMailPopup.validUntil}
                                    onChange={(value) => this.onCreateChangeTime('validUntil', value)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                    ampm={false}
                                />
                            </LocalizationProvider>

                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Subject</Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <TextField
                                label="Key"
                                value={createMailPopup.subject.key}
                                onChange={(e) => this.onChangeCreateMailPopup('subject', {...createMailPopup.subject, key: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                label="Value"
                                value={createMailPopup.subject.value}
                                onChange={(e) => this.onChangeCreateMailPopup('subject', {...createMailPopup.subject, value: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Content</Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <TextField
                                label="Key"
                                value={createMailPopup.content.key}
                                onChange={(e) => this.onChangeCreateMailPopup('content', {...createMailPopup.content, key: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                label="Value"
                                value={createMailPopup.content.value}
                                onChange={(e) => this.onChangeCreateMailPopup('content', {...createMailPopup.content, value: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Type</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                select
                                label="Type"
                                value={createMailPopup.type}
                                onChange={(e) => this.onChangeCreateMailPopup('type', e.target.value)}
                                fullWidth
                                variant="outlined"
                                size="small"
                            >
                                {MailTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Params</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                label="Params"
                                value={createMailPopup.params}
                                onChange={(e) => this.onChangeCreateMailPopup('params', e.target.value)}
                                fullWidth
                                variant="outlined"
                                rows={10}
                                multiline
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Attachment</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                label="Attachment"
                                value={createMailPopup.attachment}
                                onChange={(e) => this.onChangeCreateMailPopup('attachment', e.target.value)}
                                fullWidth
                                variant="outlined"
                                rows={10}
                                multiline
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogContentText><span style={{color: "red"}}>{createMailPopup.errorMessage}</span></DialogContentText>
            <DialogActions>
                <Button onClick={() => this.onChangeCreateMailPopup('open', false)} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => this.createMail()} color="primary" autoFocus variant="contained">
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderUpdateMailPopup() {
        const {updateMailPopup} = this.state;

        return <Dialog
            open={updateMailPopup.open}
            onClose={() => this.onChangeUpdateMailPopup('open', false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>{`Update Mail ${updateMailPopup.id}`}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Broadcast</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                disabled={true}
                                checked={updateMailPopup.isBroadcast}
                                onChange={(e) => this.onChangeUpdateMailPopup('isBroadcast', e.target.checked)}
                                name="isBroadcast"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Active</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                disabled={!updateMailPopup.isBroadcast}
                                checked={updateMailPopup.isActive}
                                onChange={(e) => this.onChangeUpdateMailPopup('isActive', e.target.checked)}
                                name="isActive"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Is Time Limited</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <Switch
                                disabled={!updateMailPopup.isBroadcast}
                                checked={updateMailPopup.isTimeLimited}
                                onChange={(e) => this.onChangeUpdateMailPopup('isTimeLimited', e.target.checked)}
                                name="isTimeLimited"
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Valid Until</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DateTimePicker
                                    label="Valid Until"
                                    disabled={!updateMailPopup.isBroadcast || !updateMailPopup.isTimeLimited}
                                    value={updateMailPopup.validUntil}
                                    onChange={(value) => this.onUpdateChangeTime('validUntil', value)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                    ampm={false}
                                />
                            </LocalizationProvider>

                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Subject</Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <TextField
                                label="Key"
                                value={updateMailPopup.subject.key}
                                onChange={(e) => this.onChangeUpdateMailPopup('subject', {...updateMailPopup.subject, key: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                label="Value"
                                value={updateMailPopup.subject.value}
                                onChange={(e) => this.onChangeUpdateMailPopup('subject', {...updateMailPopup.subject, value: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Content</Typography>
                        </Grid>
                        <Grid item sm={3}>
                            <TextField
                                label="Key"
                                value={updateMailPopup.content.key}
                                onChange={(e) => this.onChangeUpdateMailPopup('content', {...updateMailPopup.content, key: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                            />
                        </Grid>
                        <Grid item sm={6}>
                            <TextField
                                label="Value"
                                value={updateMailPopup.content.value}
                                onChange={(e) => this.onChangeUpdateMailPopup('content', {...updateMailPopup.content, value: e.target.value})}
                                fullWidth
                                variant="outlined"
                                size="small"
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Type</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                select
                                label="Type"
                                value={updateMailPopup.type}
                                onChange={(e) => this.onChangeUpdateMailPopup('type', e.target.value)}
                                fullWidth
                                variant="outlined"
                                size="small"
                            >
                                {MailTypes.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Params</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                label="Params"
                                value={updateMailPopup.params}
                                onChange={(e) => this.onChangeUpdateMailPopup('params', e.target.value)}
                                fullWidth
                                variant="outlined"
                                rows={10}
                                multiline
                            />
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2}>
                        <Grid item sm={2}>
                            <Typography>Attachment</Typography>
                        </Grid>
                        <Grid item sm={9}>
                            <TextField
                                label="Attachment"
                                value={updateMailPopup.attachment}
                                onChange={(e) => this.onChangeUpdateMailPopup('attachment', e.target.value)}
                                fullWidth
                                variant="outlined"
                                rows={10}
                                multiline
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogContentText><span style={{color: "red"}}>{updateMailPopup.errorMessage}</span></DialogContentText>
            <DialogActions>
                <Button onClick={() => this.onChangeUpdateMailPopup('open', false)} color="primary">
                    Cancel
                </Button>
                <Button onClick={() => this.deleteMail()} color="error" variant="contained">
                    Delete
                </Button>
                <Button onClick={() => this.updateMail()} color="primary" autoFocus variant="contained">
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    }

    renderPopup(content) {
        return PopupMessage.success(content);
    }

    renderFilter() {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;

        return <Paper style={style}>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                </Grid>
                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <TextField
                            label="Limit..."
                            value={filter.limit}
                            onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>
                    <Grid item sm={1}>
                        <TextField
                            label="Offset..."
                            value={filter.offset}
                            onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="primary" onClick={() => this.fetchData()}>Search</Button>
                    </Grid>

                </Grid>

                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <Button disableElevation variant="contained" color="primary" onClick={() => this.onChangeCreateMailPopup('open', true)}>
                            <AddIcon />
                            Add
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        if (this.state.loading) {
            return <TableRow key="loading-row">
                <TableCell colSpan={11}>
                    {Helpers.renderSkeletonRows(5, 50)}
                </TableCell>
            </TableRow>
        }

        const mails = this.state.mails;

        return <div style={{overflowX: 'auto', maxWidth: '100%'}}>
            <Table sx={{minWidth: 650}}>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>ID</TableCell>
                        <TableCell>Creator</TableCell>
                        <TableCell>Subject</TableCell>
                        <TableCell>Message</TableCell>
                        <TableCell>Type</TableCell>
                        <TableCell>ValidUntil</TableCell>
                        <TableCell>Active</TableCell>
                        <TableCell>CreateDate</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        mails.map((mail: any, index: number) => {
                            return <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{mail.id}</TableCell>
                                <TableCell>{mail.createdBy}</TableCell>
                                <TableCell>{mail.subject}</TableCell>
                                <TableCell>{mail.content}</TableCell>
                                <TableCell>{mail.type}</TableCell>
                                <TableCell>{mail.validUntil}</TableCell>
                                <TableCell>{mail.isActive ? TICK : CROSS}</TableCell>
                                <TableCell>{Helpers.formatDateWithTime(mail.createdAt)}</TableCell>
                                <TableCell>
                                    <Button onClick={() => this.focusOnMail(mail)}>
                                        <VisibilityIcon />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </div>
    }

    render() {
        const {classes} = this.props;
        return <Paper className="contentPadding">
            <Typography className={classes.paper} variant="h6">{`Admin Mail`}</Typography>
            {this.renderFilter()}
            {this.renderContent()}
            {this.renderCreateMailPopup()}
            {this.renderUpdateMailPopup()}
        </Paper>
    }
}

const styles: any = theme => ({
    actions: {
        color: theme.palette.text.secondary,
        float: "right",
    },
    button: {
        margin: 8,
    },
});

export const BroadcastMail = withStyles(styles)(broadcastMailMain);